<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="repairRegistrations/sc"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button v-if="limits.exportAuth" type="primary" :loading="exportLoading" @click="exportHandle">明细导出</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="报修时间">
            <el-date-picker
                v-model="faultTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('faultTimeRange', 'faultTimeStartTime', 'faultTimeEndTime')"/>
          </el-form-item>
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="已报修" :value="1"/>
              <el-option label="已修" :value="2"/>
              <el-option label="疑难杂症" :value="3"/>
              <el-option label="报废" :value="4"/>
              <el-option label="可用" :value="5"/>
              <el-option label="不可用" :value="6"/>

            </el-select>
          </el-form-item>
          <el-form-item label="工单号">
            <el-input v-model.trim="filter.productionNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="条形码">
            <el-input v-model.trim="filter.barcode" placeholder="请输入条形码" clearable @keyup.enter.native="getBarcode"/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <!--      <template slot="actionBtn" slot-scope="scope">-->
      <!--        <el-button-->
      <!--            type="primary"-->
      <!--            :disabled="scope.row.status !== 0"-->
      <!--            :loading="submitLoading"-->
      <!--            @click="submitHandle(scope.row)">-->
      <!--          提交-->
      <!--        </el-button>-->
      <!--      </template>-->
    </viewTable>
    <repair-registration-edit ref="repairRegistrationEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import RepairRegistrationEdit from "@/views/maintenanceManage/repairRegistrationSC/RepairRegistrationSCEdit";

  export default {
    name: "RepairRegistrationList",
    components: {RepairRegistrationEdit, viewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(611),
          editAuth: this.$auth(614),
          delAuth: this.$auth(615),
          exportAuth: this.$auth(611),
        },
        submitLoading: false,
        receiveTimeRange: [],
        faultTimeRange: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        exportLoading: false,
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          materialNo: "",
          materialName: "",
          barcode: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: 1,
          type: 20,
          receiveTimeBegin: "",
          receiveTimeEnd: "",
          faultTimeStartTime: "",
          faultTimeEndTime: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            align: "center",
            width: 220,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/RepairRegistrationSCPreview",
                        query: {
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "statusName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "materialNo",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "materialName",
            align: "center",
            width: 220,
          },
          {
            tooltip: true,
            key: "typeName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "receiveName",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "repairName",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "barcode",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "receiveTime",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "hardwareVersion",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "softwareVersion",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "historicalAlarms",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "faultReporting",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "faultActual",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
      // 重写导出方法，确保包含查询条件
      // const originalSureExport = this.$refs.viewTable.sureExport;
      this.$refs.viewTable.sureExport = () => {
        this.$refs.viewTable.exportLoading = true;
        let params = Object.assign({ pageNum: 1, pageSize: this.$refs.viewTable.model.exportNum }, this.filter);
        this.$http
          .exportExcel("basic", "repairRegistrations/sc", params, this.$refs.viewTable.model.exportFields.join())
          .then((res) => {
            const blob = new Blob([res.data]);
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            const contentDisposition = res.headers["content-disposition"];
            const fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1].split(".")[0]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = fileName + ".xls";
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
            this.$refs.viewTable.exportVisible = false;
            this.$refs.viewTable.exportLoading = false;
          })
          .catch(() => {
            this.$refs.viewTable.exportVisible = false;
          });
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.repairRegistrationEdit.open(row);
      },
      getBarcode() {
        if (this.filter.barcode) {
          let barcode = this.filter.barcode;
          if (barcode.includes("_")) {
            this.filter.barcode = barcode.split("_")[1];
          }
        }
      },
      printHandle() {
        // 返修品发货单
        // const path = "/returnMerchandiseDeliveryNotePrint";
        const path = "/productRepairListPrint";
        const routeUrl = this.$router.resolve({
          path: path,
          query: {
            params: JSON.stringify(this.selection[0]),
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      exportHandle() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        this.$http.exportExcel("basic", "repairRegistrations/exportSC", params)
          .then((res) => {
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            // 创建下载链接
            const link = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            // 设置下载文件名
            const fileName = `生产维修明细_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;
            link.href = url;
            link.download = fileName;
            // 触发下载
            document.body.appendChild(link);
            link.click();
            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);

            this.$message.success("导出成功");
          })
          .catch(() => {
            this.exportLoading = false;
            this.$message.error("导出失败");
          })
          .finally(() => {
            this.exportLoading = false;
          });
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "repairRegistrations", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      // otherAuth(row) {
      //   return row.status !== 0;
      // },
    },
  };
</script>
